import Cookies from 'js-cookie';

export function handleSignIn(RedirectRoute) {
    if (RedirectRoute === undefined) {
        RedirectRoute = "/";
    }

    Cookies.set('adfsRedirect', RedirectRoute);
    window.location.href = window.location.origin + '/signin';
}

export function handleSignOut(RedirectRoute) {
    if (RedirectRoute === undefined) {
        RedirectRoute = "/";
    }

    Cookies.set('adfsRedirect', RedirectRoute);
    window.location.href = window.location.origin + '/signout';
}